import React from 'react';
import { observer } from 'mobx-react';
import ErrorBoundary from 'components/hoc/error_boundary.js';
import StoriesProgress from 'components/stories/stories_progress';
import TreeShow from 'components/tree/tree_show';
import LearnLayout from 'pages/main/learn_layout';
import styled from '@emotion/styled';
import { AppUI } from '@seedlang/state';
import PageOnboarding from 'components/onboarding/page_onboarding';
import Link from 'components/link';

const Wrapper = styled.div`
  width: 100%;
`;

const LeftColumn = styled.div`
  width: 100%;
`;

@observer
class Stories extends React.Component {

  render() {
    return (
      <Wrapper>
        <LearnLayout>
          <LeftColumn>
            {
              !AppUI.user.isMember && (AppUI.targetLanguage?.contentTreeDecksFinishedCount || 0) > 0 &&
                <PageOnboarding
                  hideCloseIcon
                  className='tree-onboarding'
                  margin='0 0 10px 0'
                >
                  <span>
                    <span>Unlocking the entire <b>Stories</b> section is a </span>
                    <Link to='memberships.index' className='underline'>
                      Seedlang Pro
                    </Link>
                    <span> feature.</span>
                  </span>
                </PageOnboarding>
            }
            <TreeShow
              treeSlug='master'
            />
          </LeftColumn>
          <StoriesProgress />
        </LearnLayout>
      </Wrapper>
    );
  }
}

export default ErrorBoundary(Stories);
